/* tz-hover-qa: relocate the Wishlist King heart (<wishlist-button-collection>)
   into the .tz-hover-qa anchor inside each .product-item card, so
   component-product-item.css can pin it bottom-left of the card image
   (all viewports). Re-runs via MutationObserver because the app
   re-injects buttons and sets an inline JS-computed transform. */
(function () {
  'use strict';
  function place() {
    document.querySelectorAll('.product-item wishlist-button-collection').forEach(function (w) {
      var card = w.closest('.product-item');
      if (!card) return;
      var anchor = card.querySelector('.tz-hover-qa');
      if (!anchor) return;
      if (w.parentElement !== anchor) anchor.appendChild(w);
      var b = w.querySelector('wk-button');
      if (b && b.style.transform !== 'none') b.style.setProperty('transform', 'none', 'important');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  try {
    new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* no-op */ }
})();
